module.exports = __webpack_public_path__ + "static/media/AmazonFresh Usability Study Presentation.e005b783.pdf";